// export const version = `api/${process.env.REACT_APP_VERSION}/`;
export const loginUrl = 'auth/sendotp';
export const verifyotpUrl = 'auth/verifyotp';
export const createProfileUrl = 'auth/createProfile';
export const getMasterDataUrl = 'master-data/GetMasterData';
export const getHomePageDataUrl = 'home/gethomedata';
export const changeMobileNoUrl = 'users/changeMobileNo';
export const deleteProfileUrl = 'users/delete-profile';
